export const vehiclesMock = [
    {
        "id": 8709,
        "license_plate": "K970KP",
        "status": "available",
        "p2p_accept_status": "accepted",
        "model": {
            "mark": "Kia",
            "model": "NIRO",
            "fuel_type": "euro95",
            "transmission": "automatic",
            "number_of_doors": 5,
            "number_of_seats": 5,
            "engine_capacity": 1580
        },
        "main_photo": "https://mobielrijden-dev.s3-eu-west-1.amazonaws.com/image-cache/thumb/47b1086e-940d-11e8-bccc-a64c27e865d1?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAJU7ISGP6U7GCUVHQ%2F20260120%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20260120T081326Z&X-Amz-SignedHeaders=Host&X-Amz-Expires=1800&X-Amz-Signature=d5561fbeeea172c959c855f2a0101bd438dece337a21dffa83125f00fe1909c4",
        "location": {
            "id": 1,
            "zip": "1101AK",
            "city": "Amsterdam",
            "street": "Klokkenbergweg",
            "house_number": "17",
            "house_number_extension": "",
            "geo": {
                "latitude": "52.3022437",
                "longitude": "4.9368501"
            },
            "comment": ""
        },
        "working_hours": [
            {
                "day_of_week": 1,
                "is_active": true
            },
            {
                "day_of_week": 2,
                "is_active": true
            },
            {
                "day_of_week": 3,
                "is_active": true
            },
            {
                "day_of_week": 4,
                "is_active": true
            },
            {
                "day_of_week": 5,
                "is_active": true
            },
            {
                "day_of_week": 6,
                "is_active": true
            },
            {
                "day_of_week": 7,
                "is_active": true
            }
        ],
        "full_filled": []
    }
]